import { render, staticRenderFns } from "./HistoricoPacotesPacienteModal.vue?vue&type=template&id=1d878b12&"
import script from "./HistoricoPacotesPacienteModal.vue?vue&type=script&lang=js&"
export * from "./HistoricoPacotesPacienteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports